import { render, staticRenderFns } from "./DashR_Result_StockWithoutInvoice.vue?vue&type=template&id=28770baa"
import script from "./DashR_Result_StockWithoutInvoice.vue?vue&type=script&lang=js"
export * from "./DashR_Result_StockWithoutInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports